import React, { useEffect } from 'react';
import './admin.css';

const Toast = ({ message, type = 'success', onClose, duration = 3000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div className={`admin-toast admin-toast-${type}`}>
      <span className="admin-toast-icon">
        {type === 'success' ? '✓' : type === 'error' ? '✗' : 'ℹ'}
      </span>
      <span className="admin-toast-message">{message}</span>
      <button className="admin-toast-close" onClick={onClose}>×</button>
    </div>
  );
};

export default Toast;

